import * as Yup from 'yup';
export const validationSchema = () =>
  Yup.object({
    companyAddresses: Yup.array().of(
      Yup.object().shape({
        addressLine1: Yup.string().required('Required').nullable(),
      })
    ),
  });
